import {
    FormControl,
    FormHelperText,
    InputLabel,
    Select
} from '@material-ui/core';
import { ASIM } from 'consts';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {},
    row: {
        height: 42,
        display: 'flex',
        alignItems: 'left',
        marginTop: theme.spacing(1)
    },
    spacer: { flexGrow: 10 },
    select: {
        '& .MuiSelect-root': {
            padding: theme.spacing(2),
            borderRadius: 4,
            border: 'none',
            boxShadow: 'none',
            height: 25
        },
        '& option': {
            padding: theme.spacing(1),
            borderRadius: 4,
            margin: 0
        }
    },
    inputLabel: {
        backgroundColor: '#f4f6f8',
        padding: '0 8px',
        zIndex: 1,
        transform: 'translate(14px, -6px) scale(0.75)',
        marginBottom: theme.spacing(2)
    },
    helperTextError: { color: 'red' }
});

class ComboPadrao extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.value !== this.props.value ||
            nextProps.listItems !== this.props.listItems ||
            nextProps.helperText !== this.props.helperText ||
            nextProps.error !== this.props.error ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.height !== this.props.height
        );
    }

    render() {
        const {
            classes,
            disabled,
            error,
            fieldDescription,
            fieldId,
            height,
            helperText,
            label,
            listItems,
            name,
            onChange,
            value
        } = this.props;

        const normalizedValue = value === undefined || value === null || value === '' ? '' : String(value);

        const selectedItem = Array.isArray(listItems) ? listItems.find(
            item => String(item?.[fieldId]) === normalizedValue
        ) : null;

        const labelId = `label-${name}`;
        const selectId = `select-${name}`;

        return (
            <FormControl
                fullWidth
                error={error}
                variant="outlined"
                disabled={disabled}
            >
                <InputLabel
                    id={labelId}
                    htmlFor={selectId}
                    className={classes.inputLabel}
                    shrink
                >
                    {label}
                </InputLabel>

                <Select
                    native
                    labelId={labelId}
                    id={selectId}
                    value={normalizedValue}
                    onChange={onChange}
                    disabled={disabled}
                    inputProps={{ name: name }}
                    style={{
                        color: selectedItem && selectedItem.inativo === ASIM ? 'red' : 'black',
                        height: height || ''
                    }}
                >
                    <option
                        value={'0'}
                        aria-label="Não Definido"
                    ></option>

                    {Array.isArray(listItems) && listItems.map(item => (
                        <option
                            key={item[fieldId]}
                            value={item[fieldId] === undefined || item[fieldId] === null ? '' : String(item[fieldId])}
                            style={{
                                color: item.inativo === ASIM ? 'red' : 'black',
                                backgroundColor: item.inativo === ASIM ? '#ff9999' : 'inherit'
                            }}
                        >
                            {item[fieldDescription]}
                        </option>
                    ))}
                </Select>

                {helperText && (
                    <FormHelperText className={classes.helperTextError}>
                        {helperText}
                    </FormHelperText>
                )}
            </FormControl>
        );
    }
};

ComboPadrao.propTypes = {
    classes: PropTypes.object.isRequired,
    fieldDescription: PropTypes.string.isRequired,
    fieldId: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    error: PropTypes.bool,
    listItems: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    height: PropTypes.string,
    disabled: PropTypes.bool
};

ComboPadrao.defaultProps = {
    helperText: '',
    error: false,
    height: '',
    disabled: false
};

export default withStyles(styles)(ComboPadrao);